export const messages = {
  title: {
    id: 'address.Title',
    defaultMessage: 'Address',
  },
  label: {
    address1: {
      id: 'address.Label.Address1',
      defaultMessage: 'Address 1',
    },
    address2: {
      id: 'address.Label.Address2',
      defaultMessage: 'Address 2',
    },
    city: {
      id: 'address.Label.City',
      defaultMessage: 'City',
    },
    zipcode: {
      id: 'address.Label.PostalCode',
      defaultMessage: 'Zip Code',
    },
    state: {
      id: 'address.Label.State',
      defaultMessage: 'State',
    },
    country: {
      id: 'address.Label.Country',
      defaultMessage: 'Country',
    },
    selectOne: {
      id: 'address.Label.SelectOne',
      defaultMessage: 'Select one...',
    },
    usePatientAddress: {
      id: 'address.Label.UsePatientAddress',
      defaultMessage: 'Use same address as patient',
    },
  },
};
